/* eslint-disable */
jQuery(function ($) {

   // Load carousel for tutorials
    if ( $( '.tutorial-slider' ).length > 0 ) {
        // If touch is not enabled on smaller device tag next & prev buttons to force different styling
        var has_touch = 'ontouchstart' in window;
        if ( $( window ).width() < 992 && ! has_touch ) {
            $( '.tutorial-slider .left, .tutorial-slider .right' ).addClass( 'display-over' );
        }

        var number_of_slides = get_number_of_slides();

        $( '.tutorial-slider' ).each( function() {
            var total_slides = parseInt( $( this ).data( 'amount' ) );
            var count        = parseInt( $( this ).data( 'count' ) );
            $( this ).find( '.left' ).hide();
            maybe_show_next_button( $( this ), number_of_slides, total_slides, count );
            if ( $( window ).width() >= 992 ) {
                if ( total_slides > 4 ) {
                    $( this ).find( '.tutorial-single' ).each( function() {
                        if ( $( this ).data( 'slide-no' ) > 4 ) {
                            $( this ).hide();
                        }
                    });
                }
            }
            if ( $( this ).closest( '.saved' ).length ) {
                $( this ).find( '.tutorial-single' ).each( function() {
                    $( this ).append( '<a href="#" data-nonce="'+window.tutorial_data.remove_nonce+'" class="remove" data-type="bookmark">remove</a>' );
                });
            }
            if ( $( this ).closest( '.courses' ).length || $( this ).closest( '.in-progress' ).length ) {
                $( this ).find( '.tutorial-single' ).each( function() {
                    if ( $( this ).hasClass( 'completed' ) ) {
                        return;
                    }
                    if ( 'course' == $( this ).data( 'type' ) ) {
                        $( this ).append( '<a href="#" data-nonce="'+window.tutorial_data.remove_nonce+'" class="remove unenroll" data-type="in-progress">unenroll</a>' );
                    } else {
                        $( this ).append( '<a href="#" data-nonce="'+window.tutorial_data.remove_nonce+'" class="remove" data-type="in-progress">remove</a>' );
                    }
                });
            }
        });

        $( '.tutorial-slider' ).show();

        $(".tutorial-slider").swipe( {
            //Generic swipe handler for all directions
            swipeLeft:function() { $(this).find('.right').trigger('click'); },
            swipeRight: function() { $(this).find('.left').trigger('click'); }
        });

        $( '.tutorial-slider' ).on( 'click', '.right', function( e ) {
            e.preventDefault();

            var slider            = $( this ).closest( '.tutorial-slider' );
            var slider_inner      = slider.find( '.tutorial-slider-inner' );
            var number_of_slides  = get_number_of_slides();
            var total_slides      = parseInt( $( slider ).data( 'amount' ) );
            var count             = parseInt( $( slider ).data( 'count' ) );

            if ( $( window ).width() >= 992 ) {
                if ( count >= ( total_slides - number_of_slides ) ) {
                    return;
                }
                ++count; $( slider ).data( 'count', count );
                $( slider ).find( '.tutorial-single:nth-child(' + (count+number_of_slides) + ')' ).fadeIn();
                $( slider ).find( '.tutorial-single:nth-child(' + (count) + ')' ).fadeOut();
                $( slider ).find( '.left' ).show();
                if ( count >= ( total_slides - number_of_slides ) ) {
                    $( slider ).find( '.right' ).hide();
                }
            } else {
                if ( $( slider_inner ).width() + $( slider_inner ).position().left - ( $( window ).width()/2 ) <= $( window ).width() ) {
                    $( slider ).find( '.right' ).hide();
                }
                if ( $( slider_inner ).width() + $( slider_inner ).position().left <= $( window ).width() ) {
                    return;
                }
                var position = 100 * $( slider_inner ).position().left / $( window ).width();
                $( slider_inner ).animate(
                    { left: ( position - 73 ) + 'vw'  }
                );
                $( slider ).find( '.left' ).show();
                ++count; $( slider ).data( 'count', count );
            }
        });
        $( '.tutorial-slider' ).on( 'click', '.left', function( e ) {
            e.preventDefault();
            var slider            = $( this ).closest( '.tutorial-slider' );
            var slider_inner      = slider.find( '.tutorial-slider-inner' );
            var number_of_slides  = get_number_of_slides();
            var total_slides      = parseInt( $( slider ).data( 'amount' ) );
            var count             = parseInt( $( slider ).data( 'count' ) );
            
            if ( $( window ).width() >= 992 ) {
                if ( 0  == count ) {
                    return;
                }
                $( slider ).find( '.tutorial-single:nth-child(' + (count+number_of_slides) + ')' ).fadeOut();
                $( slider ).find( '.tutorial-single:nth-child(' + (count) + ')' ).fadeIn();
                --count; $( slider ).data( 'count', count );
                if ( count == 0 ) {
                    $( slider ).find( '.left' ).hide();
                }
                maybe_show_next_button( slider, number_of_slides, total_slides, count );
            } else {
                if ( count < 2 ) {
                    $( slider ).find( '.left' ).hide();
                }
                if ( 0 <= $( slider_inner ).position().left ) {
                    return;
                }
                var position = 100 * $( slider_inner ).position().left / $( window ).width();
                $( slider_inner ).animate(
                    { left: ( position + 73 ) + 'vw'  }
                );
                $( slider ).find( '.right' ).show();
                --count; $( slider ).data( 'count', count );
            }
        });
        $( window ).on( 'resize', function() {
            $( '.tutorial-slider' ).each( function() {
                reset_slider( $( this ) );
            });
        });
    }
    if ( $( '.my-progress .saved' ).length && ! $( '.my-progress .saved .tutorial-slider' ).length ) {
        $( '.saved p.empty' ).show();
    }
    // Remove bookmark when "remove" link clicked
    $( '.tutorial-slider' ).on( 'click', 'a.remove', function(e) {
        e.preventDefault();
        $( this ).hide();
        $( '<div class="spinner is-active"></div>' ).insertAfter( $( this ) );
        var slide  = $( this ).closest( '.tutorial-single' );
        var slider = $( this ).closest( '.tutorial-slider' );

        var data = {
            'tutorial_id': slide.data( 'id' ),
            'action': 'in-progress' == $( this ).data( 'type' ) ? 'remove_current' : 'remove_bookmark',
            'nonce': $( this ).data( 'nonce' )
        }
        $.post( ajaxurl, data, function( response ) {
            slide.remove();
            var slide_no = 1;
            $( slider ).find( '.tutorial-single' ).each( function() {
                $( this ).data( 'slide-no', slide_no );
                slide_no++;
            });
            var amount = parseInt( $( slider ).data( 'amount' ) ) - 1;
            $( slider ).data( 'amount', amount );
            var total_slides = amount;
            if ( total_slides > 0 ) {
                reset_slider( $( slider ) );
            } else {
                $( slider ).remove();
                $( slider ).prev( 'p.empty' ).show();
            }
        });
    });
    function reset_slider( slider ) {
        var number_of_slides = get_number_of_slides();
        slider.find( '.tutorial-slider-inner' ).css( 'left', 0 );
        slider.data( 'count', 0 )
        if ( $( window ).width() >= 992 ) {
            slider.find( '.left' ).removeClass( 'display-over' );
            slider.find( '.right' ).removeClass( 'display-over' );
            var total_slides = slider.data( 'amount' );
            slider.find( '.tutorial-single' ).show();
            slider.find( '.tutorial-single' ).slice( number_of_slides ).hide();
            slider.find( '.left' ).hide();
            maybe_show_next_button( slider, number_of_slides, total_slides, 0 );
        } else {
            if ( ! has_touch ) {
                slider.find( '.left' ).addClass( 'display-over' );
                slider.find( '.right' ).addClass( 'display-over' );
                if ( slider.find( '.tutorial-slider-inner' ).width() >= $( window ).width() ) {
                    slider.find( '.right' ).show();
                }
            }
            slider.find( '.tutorial-single' ).show();
        }
    }
    function get_number_of_slides() {
        return 4
    }
    function maybe_show_next_button( slider, number_of_slides, total_slides, count ) {
        if ( number_of_slides < total_slides ) {
            slider.find( '.right' ).show();
        }
        if ( count >= ( total_slides - number_of_slides ) ) {
            slider.find( '.right' ).hide();
        }
    }
});
